<!--
 * @Descripttion: 房产制度
 * @Author: chenjinsheng
 * @Date: 2021-08-10 16:14:11
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 14:59:12
-->
<template>
    <div v-if="checkPermission('UDWWB_OFFICIAL_SYSTEM')" class="institution-container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="{ title, key } in tabList" :key="key" :label="title" :name="key" />
        </el-tabs>
        <div v-loading="loading" :class="['ins-content', { center: dataList.length === 0 }]">
            <div v-for="(item, index) in dataList" :key="index" class="ins-item" @click="openWin(item.url)">
                <p>
                    <span v-if="item.isNew" class="new">[新] </span>
                    {{ item.name }}
                </p>
                <p>
                    <span>{{ item.createDate | dateFilter }}</span>
                </p>
            </div>
            <div v-show="dataList.length === 0" class="noData">
                <no-empty>暂无数据</no-empty>
            </div>
        </div>
        <div class="more"><span @click="viewMore">查看更多</span></div>
    </div>
</template>

<script>
import { getKnowledge } from "@/api";
import NoEmpty from "@/components/no-empty";
export default {
    components: {
        NoEmpty,
    },
    data() {
        return {
            loading: false,
            activeName: "first",
            systemJumpUrl: this.$config.systemOAURLFull,
            tabList: [
                {
                    title: "房产制度",
                    key: "first",
                },
            ],
            dataList: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.loading = true;
            try {
                const { body, code, message } = await getKnowledge(30);
                if (code === "0000") {
                    this.dataList = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
                // this.$message.error(err);
            }
            this.loading = false;
        },
        openWin(url) {
            window.open(url);
        },
        viewMore() {
            window.open(this.systemJumpUrl);
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
    },
};
</script>

<style lang="scss" scoped>
.institution-container {
    position: relative;
    height: 400px;
    padding: 10px 20px 0 20px;
    background: #fff;
    border-radius: 8px;
    box-sizing: border-box;
    margin-top: 5px;
    /deep/ .el-tabs__header {
        margin-bottom: 0;
    }
    /deep/ .el-tabs__item {
        font-weight: bold;
    }
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        & > span {
            font-size: 14px;
            font-weight: 400;
            color: #666666;
        }
    }
    /deep/ .el-tabs {
        .el-tabs__item.is-active {
            color: #666666;
        }
        .el-tabs__active-bar {
            background-color: transparent;
        }
    }
    .ins-content {
        &.center {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        width: 100%;
        height: 307px;
        overflow-y: auto;
        overflow-x: hidden;
        .ins-item {
            position: relative;
            display: flex;
            align-items: center;
            // margin-bottom: 18px;
            font-size: 13px;
            padding: 12px 0;
            cursor: pointer;
            .new {
                margin-right: 5px;
                color: #e23b50;
            }
            p:first-child {
                display: flex;
                justify-content: flex-start;
                flex-wrap: nowrap;
                width: 75%;
                line-height: 20px;
                color: #333333;
            }
            p:last-child {
                position: absolute;
                right: 0;
                top: 12px;
                width: 24%;
                height: auto;
                text-align: right;
                color: #666666;
                white-space: nowrap;
                padding-right: 5px;
                span {
                    position: relative;
                    right: 2px;
                }
            }
            &:hover {
                background: #f2f2f2;
                box-shadow: 0px 1px 0px 0px rgba(203, 205, 211, 0.4);
            }
        }
    }
    .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        left: 20px;
        right: 20px;
        bottom: 0;
        height: 43px;
        border-top: 1px solid #e1e2e3;
        span {
            font-size: 14px;
            color: #666666;
            cursor: pointer;
        }
    }
}
</style>
